import type { ReactNode } from "react";
import { useNative } from "../../../shared/phone/media";
import { Sheet as PnSheet } from "../../../shared/phone/Sheet";
import { Sheet } from "../../components/ui/Sheet";

/**
 * A sheet opened from a goal's chat or page: the kit's own on a phone and an iPad, drawn over the whole screen
 * (a sheet drawn inside a chat message is trapped in the message's box), and today's dialog on a computer.
 */
export function AnySheet({ open, onClose, label, className, children }: { open: boolean; onClose: () => void; label: string; className?: string; children: ReactNode }) {
  const native = useNative();
  if (native)
    return (
      <PnSheet open={open} onClose={onClose} label={label}>
        <div className={`ga gw ccx gp-in${className ? ` ${className}` : ""}`}>{children}</div>
      </PnSheet>
    );
  return (
    <Sheet open={open} onClose={onClose} label={label} className={className}>
      {children}
    </Sheet>
  );
}
